module.exports = __webpack_public_path__ + "images/emoji/railway_car.ee571754b94a9be677c8.png";